export const avatars: Record<string, string>  = {
    "Jake":'/images/jake.png',
    "Princess Bubblegum":'/images/bubblegum.png',
    "Finn":'/images/finn.png',
    "BMO":'/images/BMO.png'
}

export const people: Users = {
    'Jake': [{
        id: 't1',
        title: 'delectus aut autem',
        completed: false
    }, {
        id: 't2',
        title: 'quis et nam facilis et officia qui',
        completed: true
    }, {
        id: 't3',
        title: 'fugiat veniam minus',
        completed: true
    }, {
        id: 't4',
        title: 'et porro tempora',
        completed: false
    }, {
        id: 't5',
        title: 'laboriosam mollitia et enim quasi adipisci quia provident illum',
        completed: false
    }],
    'Princess Bubblegum': [{
        id: 't6',
        title: 'qui ullam ratione quibusdam voluptatem quia omnis',
        completed: false
    }, {
        id: 't7',
        title: 'illo expedita consequatur quia in',
        completed: false
    }, {
        id: 't8',
        title: 'quo adipisci enim quam ut ab',
        completed: true
    }],
    'Finn': [{
        id: 't9',
        title: 'molestiae perspiciatis ipsa',
        completed: true
    }, {
        id: 't10',
        title: 'illo est ratione doloremque quia maiores aut',
        completed: true
    }, {
        id: 't11',
        title: 'vero rerum temporibus dolor',
        completed: false,
    }, {
        id: 't12',
        title: 'ipsa repellendus fugit nisi',
        completed: true
    }],
    'BMO': [{
        id: 't13',
        title: 'et doloremque nulla',
        completed: true
    }, {
        id: 't14',
        title: 'repellendus sunt dolores architecto voluptatum',
        completed: true
    }, {
        id: 't15',
        title: 'ab voluptatum amet voluptas',
        completed: false
    }]
}